import { openModal } from '@actions/ui';
import { UserSession } from '@app/types';
import { Dispatch } from 'redux';
import openURL from './open-url';

export default function upgradeAction(user: UserSession, dispatch: Dispatch): () => void {
  if (window.desktopIntegrations?.appInfo.isMAS) {
    return () => dispatch(openModal('iAPUpgrade'));
  } else {
    return () => openURL(user.upgrade_url);
  }
}
